<template>
  <div class="email-bg">
    <div class="email-flex">
      <div style="width:420px;margin:30px;">
        Dear All<br />
        <br/>
        Here is some text,<br>
        <br/>
        Best Wishes,<br>
        <div ref="sigarea">
          <div style="font-family:gibbs, arial;font-size:16px;margin-top:20px">
            <table border="0" cellspacing="0" cellpadding="0" style="width:420px" width="420">
              <tr valign="bottom">
                <td>
                  <img :src="$emailImageUrl('sigs/' + selSig)" style="height:70px"/>
                </td>
                <td rowspan="2">
                  <img :src="$emailImageUrl('portraits/' + selPortrait)" style="height:135px" />
                </td>
              </tr>
              <tr>
                <td style="font-family:gibbs, arial;font-size:16px;line-height:24px">
                  <div style="font-weight:500">{{ name }}</div>
                  <div style="font-size:14px;color:#a67c52">{{ jobTitle }}</div>
                  <div style="margin-top:18px">
                    <span style="color:#ce0e2d">T</span> {{ tel }}
                  </div>
                  <div style="color:#ce0e2d">
                    <a :href="'mailto:' + email" style="color:#ce0e2d;text-decoration:none">{{ email }}</a>
                  </div>
                </td>
              </tr>
            </table>

            <table border="0" cellspacing="0" cellpadding="0" style="width:420px;margin-top:26px" width="420">
              <tr>
                <td style="font-size:18px">
                  <img :src="$emailImageUrl('logos/email-illustration@2x.png')" width="191" /><br/>
                  <a href="https://www.illustrationx.com" style="color:#ce0e2d;text-decoration:none">www.illustrationx.com</a>
                </td>
                <td> &nbsp; </td>
                <td>
                  <img :src="$emailImageUrl('logos/email-animation@2x.png')" width="161" /><br/>
                  <a href="https://www.animationx.com" style="color:#ce0e2d;text-decoration:none">www.animationx.com</a>
                </td>
              </tr>
            </table>
            <div style="margin-top:30px">
              <a href="https://www.illustrationx.com/weeklyportfolio"><img :src="$emailImageUrl('portfoliopreview.png')" style="width:420px" /></a>
            </div>
            
          </div>
        </div>
      </div>
      <div class="mform">
        <div style="margin-bottom:30px;border:1px solid #ccc;border-radius:8px;padding:20px;">
          <p>Upload new file</p>
          <div style="margin-bottom:20px;">
            <select v-model="ftype">
              <option value="weekly">Weekly image</option>
              <option value="sigs">Signature</option>
              <option value="portraits">Portrait</option>
            </select>
            <input type="file" name="file" ref="fileInput" />
          </div>
          <button v-on:click="handleSave">Upload</button>
          <div v-show="loading">Uploading...</div>
        </div>
        <div class="editform">
          <div class="tab-buttons">
            <button v-on:click="showEdit" :class="{sel: mode === 'editor'}">Editor</button>
            <button v-on:click="showWeekly" :class="{sel: mode === 'weekly'}">Weekly images</button>
            <button v-on:click="showSignatures" :class="{sel: mode === 'sigs'}">Signatures</button>
            <button v-on:click="showPortraits" :class="{sel: mode === 'portraits'}">Portraits</button>
          </div>
          <div class="tabtop">
            <div v-show="mode === 'editor'">
              <input type="text" placeholder="Name" v-model="name" >
              <input type="text" placeholder="Job title" v-model="jobTitle">
              <input type="text" placeholder="Telephone" v-model="tel">
              <input type="text" placeholder="Email" v-model="email">
              <textarea v-model="code" cols="80" rows="20" ref="codearea"></textarea>
              <button v-on:click="copyToClipboard">Copy html code to clipboard</button>
            </div>
            
            <div v-show="mode === 'weekly'">
               <div style="margin-bottom:20px">
                <div>
                  Weekly link: https://www.illustrationx.com/<input type="text" name="wlink" v-model="wlink" /><br>
                  <div style='font-weight:bold;cursor:pointer' v-on:click="showFollowers = !showFollowers">IllustrationX Followers -&gt;</div>
                  <div v-show="showFollowers">
                    Instagram <input type="text" v-model="settings.social.counts.instagram"><br>
                    Twitter <input type="text" v-model="settings.social.counts.twitter"><br>
                    Pinterest <input type="text" v-model="settings.social.counts.pinterest"><br>
                    Facebook <input type="text" v-model="settings.social.counts.facebook"><br>
                  </div>
                  <button v-on:click="saveWeekly" >Update</button>
                  <br>
                  <br>
                  Test: <a :href="'https://www.illustrationx.com/' + wlink">www.illustrationx.com/{{ wlink }}</a>
                </div>
                <div style="margin:10px 0">
                  Current Weekly image:<br>
                  <img src="https://media.illustrationx.com/mediastore/emails/portfoliopreview.png" width="420"/>
                </div>
              </div>
              <div class="weeklies">
                <div v-for="item in weekly" :key="item.path" class="weekly-item">
                  <div><img :src="$emailImageUrl('weekly/' + item.filename)" style="width:420px" /></div>
                  <div>
                    <button v-on:click="setLive(item.filename)">Make Live</button> |
                    <button v-on:click="deleteWeekly(item.filename)">Delete</button>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="mode === 'portraits'" class="matrix">
              <div v-for="item in portraits" :key="item.path" v-on:click="selectPortrait(item.filename)">
                <img :src="$emailImageUrl('portraits/' + item.filename)" style="height:135px" />
                {{ item.filename }}
              </div>
            </div>
            <div v-show="mode === 'sigs'" class="matrix">
              <div v-for="item in sigs" :key="item.path" v-on:click="selectSig(item.filename)">
                <img :src="$emailImageUrl('sigs/' + item.filename)" style="max-width:120px" />
                {{ item.filename }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      code: '',
      name: 'Victoria Dyer',
      jobTitle: 'Senior Agent / Creative & Marketing',
      tel: '020 7720 5202',
      email: 'victoria@illustrationx.com',
      mode: 'editor',
      ftype: 'weekly',
      artists: [],
      wlink: '',
      settings: {
        social: {
          counts: {}
        }
        
      },
      showFollowers: false,
      sigs: [],
      portraits: [],
      weekly: [],
      selPortrait: 'Vicky.jpg',
      selSig: 'VickySignature.jpg',
      loading: false
    }
  },
  mounted () {
    this.updateCode()
  },
  updated () {
    this.updateCode()
  },
  created () {
    this.init()
  },
  methods: {
    selectSig(fname) {
      this.selSig = fname
      
    },
    selectPortrait(fname) {
      this.selPortrait = fname
      this.ftype = 'portraits'
    },
    async init() {
      await this.loadSettings()
      this.wlink = this.settings.weekly
    },
    showEdit() {
      this.mode = 'editor'
      this.ftype = 'weekly'
    },
    showUpload() {
      this.mode = 'upload'
    },
    async setLive(filename) {
      let res = await this.$apix.post('events/setweeklyimage', {weekly: filename }, { headers: {'Authorization': this.$store.state.adminToken } })
      if(res.data.message === 'ok'){
        alert('Made this the current weekly image')
      }
      else {
        console.log(res.data)
      }
    },
    async deleteWeekly(filename) {
      let path = 'mediastore/emails/weekly/' + filename
      let res = await this.$apix.post('events/delete-file', { path: path }, { headers: {'Authorization': this.$store.state.adminToken } })
      if(res.data.message === 'ok'){
        this.weekly = await this.getList('weekly')
        alert('File ' + filename + ' deleted')
      }
      else {
        console.log(res.data)
      }
    },
    async showWeekly() {
      this.mode = 'weekly'
      this.weekly = await this.getList('weekly')
      this.ftype = 'weekly'
    },
    async showSignatures() {
      this.mode = 'sigs'
      this.sigs = await this.getList('sigs')
      this.ftype = 'sigs'
    },
    async showPortraits() {
      this.mode = 'portraits'
      this.portraits = await this.getList('portraits')
      this.ftype = 'portraits'
    },
    updateCode() {
      let code = this.$refs.sigarea.innerHTML
      this.code = code
    },
    copyToClipboard() {
      this.$refs.codearea.select()
      document.execCommand("copy");
    },
    handleSave: async function () {
      let files = this.$refs.fileInput.files
      if (files.length < 1) {
        this.$k.messageBox('No files to upload.')
        return
      }
      this.loading = true
      const reader = new FileReader();
      this.loading = true
      reader.onload = () => {
          const b64 = btoa(reader.result);
          this.filename = files[0].name
          this.saveData(b64)
      }
      reader.readAsBinaryString(files[0]);
    },
    saveData: async function (b64) {
      let naming = 'original'
      if(this.ftype === 'weekly') {
        naming = 'random'
      } 
      let info = { file: b64, origFilename: this.filename, foldername: 'emails/' + this.ftype, naming: naming, thumbs: false }
      let res = await this.$dapix.post('files/put', info,  { headers: {'Authorization': this.$store.state.adminToken } })
      console.log('res ', res.data)
      let url = res.data.url
      console.log('added url', url)
      this.loading = false
      if(this.ftype === 'sigs') {
        this.sigs = await this.getList('sigs')
      }
      else if(this.ftype === 'portraits'){
        this.portraits = await this.getList('portraits')
      }
      else if(this.ftype === 'weekly') {
        this.weekly = await this.getList('weekly')
      }
    },
    async loadSettings() {
      let res = await this.$apix.get(this.$imagehost + '/data/settings.json')
      this.settings = res.data
    },
    async getList(akey) {
      let res = await this.$apix.post('events/s3list', { key: 'mediastore/emails/' + akey + '/' }, { headers: {'Authorization': this.$store.state.adminToken } })
      let m = res.data.filter(el => el.endsWith('.jpg')|| el.endsWith('.png'))
      let arr = []
      for(let each of m) {
        
        let fname = each.split('/').pop()
        if(fname !== 'portfoliopreview.png')
        {
          arr.push({ path: each, filename: fname })
        }
        
      }
      return arr
    },
    async saveWeekly() {
      if(!this.settings) {
        await this.loadSettings()
      }
      this.settings.weekly = this.wlink
      console.log('settings is now', this.settings)
      let res = await this.$apix.post('events/settings', { settings: this.settings }, { headers: {'Authorization': this.$store.state.adminToken } })
      if(res.data.message != 'ok') {
        alert(res.data.message)
      }
      else {
        alert('link updated')
      }
    }
  }
}
</script>

<style>
.email-bg{
  background-color:#fff;
  padding:45px;
}

.email-flex{
  display:flex;
  justify-content: flex-start;
}

.tabtop{
  border-top:1px solid #ccc;
  padding-top:20px;
}

.mform{
  margin-left:20px;
  border-left:1px solid #ccc;
  padding-left:20px;
}

.mform button{
  cursor:pointer;
}

.mform button.sel{
  font-weight: bold;
}

.mform input[type="text"]{
  width: 400px;
  display:block;
  margin-bottom:10px;
}

.mform textarea{
  display:block;
}

.matrix{
  display:flex;
  flex-wrap: wrap;
}

.matrix div{
  margin:10px;
  cursor:pointer;
  font-size:12px;
}

.matrix div img{
  display:block;
}

.matrix div:hover{
  box-shadow:0 0 3px rgba(0,0,0,0.4);
}

.weekly-item{
  margin:10px 0;
  padding:10px;
  border:1px solid #eee;
  border-radius:6px;
}

.weekly-item:hover{
  border:1px solid #ccc;
  box-shadow:0 0 4px rgba(0,0,0,0.4);
}

.tab-buttons button{
  margin-right:6px;
}
</style>